<div class="font-md"
     [innerHTML]="'orderProcess.giftDelivery.description' | translate">
  If you are sending to someone else, you can let them choose themselves when it is convenient for them to have it
  delivered. The message will be sent by SMS and email to them. You can add a personal message, and choose when the
  message will be sent to them.
</div>

<div class="font-h4 fw-bold mt-4 mb-3"
     [translate]="'orderProcess.giftDelivery.recipientsForm.title'">
  Recipients information
</div>

<gift-delivery-recipients-form
  [delivery]="delivery"
  [countryCode]="countryCode"
  (onDataChanged)="recipientsDataChanged($event)"
  (onValidChange)="recipientFormIsValid = $event"
></gift-delivery-recipients-form>

<ng-container *ngIf="isToDoorAvailable && isPickUpAvailable then deliveryTypeSelector"></ng-container>
<ng-container *ngIf="isToDoorAvailable && !isPickUpAvailable then onlyToDoorMessage"></ng-container>
<ng-container *ngIf="!isToDoorAvailable && isPickUpAvailable then onlyPickupMessage"></ng-container>

<div class="gift-margin-top">
  <button class="btn btn-pink font-lg"
          [translate]="'orderProcess.delivery.goToPayment'"
          [disabled]="!isDeliveryValid"
          (click)="submit()">
    Go to payment
  </button>
</div>

<ng-template #onlyPickupMessage>
  <ui-message-custom class="font-md d-block gift-margin-top">
    <span class="me-1"
          [translate]="'orderProcess.giftDelivery.onlyPickupMessage'">
      The recipient will choose where and when they want to pick up the order. He can choose among the bakery´s
      locations.
    </span>

    <span class="pointer text-blue-2" (click)="onShowOutletsMap.emit()"
          [translate]="'orderProcess.giftDelivery.seeMapOfLocations'">
      See map of locations.
    </span>
  </ui-message-custom>
</ng-template>

<ng-template #onlyToDoorMessage>
  <ui-message-custom class="font-md d-block gift-margin-top">
    <div [innerHTML]="'orderProcess.giftDelivery.onlyToDoorMessage' | translate: {
          price: (deliveryDeposit | currencyFormat: currency)
    }"></div>
  </ui-message-custom>
</ng-template>

<ng-template #deliveryTypeSelector>
  <div class="font-h4 fw-bold gift-margin-top"
       [translate]="'orderProcess.giftDelivery.howDeliverTitle'">
    How should it be delivered?
  </div>

  <div class="font-sm text-muted"
       [translate]="'orderProcess.giftDelivery.howDeliverDescription'">
    The recipient will choose where and when they want it delivered. You can choose if they will
    get it delivered to door or pick it up in one of the bakery´s locations.
  </div>

  <gift-delivery-type-selector
    class="d-block mt-3"
    [currency]="currency"
    [type]="type"
    [price]="deliveryDeposit"
    [pickupPointsCount]="pickupPointsCount"
    (onDataChanged)="type=$event"
    (onShowOutletsMap)="onShowOutletsMap.emit()"
  ></gift-delivery-type-selector>
</ng-template>



<!--<div class="font-h4 fw-bold gift-margin-top"-->
<!--     [translate]="'orderProcess.giftDelivery.whenShouldBeSent'">-->
<!--  When should the SMS/email be sent to the recipient?-->
<!--</div>-->

<!--<gift-send-message-selector-->
<!--  class="d-block mt-3"-->
<!--  [sendingOption]="sendMailAsap"-->
<!--  (onDataChanged)="sendMessageSelectorChanged($event)"-->
<!--&gt;</gift-send-message-selector>-->

<!--<div class="row mt-3" *ngIf="!sendMailAsap">-->
<!--  <div class="col-6 col-lg-4 pe-2 pr-xs-max-1">-->
<!--    <label class="text-bold font-sm d-none d-md-block"-->
<!--           #datePickerLabel-->
<!--           [translate]="'common.timing.date'">-->
<!--      Date-->
<!--    </label>-->

<!--    <ui-datepicker-popup-->
<!--      [minDate]="today"-->
<!--      (modelChange)="selectedDate = $event"-->
<!--      [model]="selectedDate"-->
<!--    ></ui-datepicker-popup>-->
<!--  </div>-->

<!--  <div class="col-6 col-lg-4 ps-2 pl-xs-max-1">-->
<!--    <label class="text-bold font-sm d-none d-md-block"-->
<!--           [translate]="'common.timing.time'">-->
<!--      Time-->
<!--    </label>-->

<!--    <div class="dropdown-container dropdown-item-slim">-->
<!--      <div ngbDropdown role="group" #rangeDropDown="ngbDropdown">-->
<!--        <button class="btn btn-select fw-normal"-->
<!--                [class.attention-select]="!selectedTimeRange && timeRanges"-->
<!--                ngbDropdownToggle>-->
<!--          {{ selectedTimeRange || ('common.timePlaceholder' | translate) }}-->
<!--        </button>-->

<!--        <div class="dropdown-menu" ngbDropdownMenu>-->
<!--          <button class="dropdown-item w-100 fw-normal"-->
<!--                  (click)="selectedTimeRange=range"-->
<!--                  [class.selected]="selectedTimeRange===range"-->
<!--                  *ngFor="let range of timeRanges">{{range}}-->
<!--          </button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
